import get from 'lodash/get';
import keyBy from 'lodash/keyBy';
import map from 'lodash/map';
import uniqBy from 'lodash/uniqBy';

import {FEATURE_SOURCE_ALL} from '../../config';

const initialState = [];

function buildHierarchy({tag_groupsa: tagGroups = [], tags = []}) {
	const normalizedGroups = keyBy(
		tagGroups.map((tagGroup) => ({
			id: tagGroup.id,
			name: tagGroup.name,
			children: [],
		})),
		'id'
	);
	const normalizedTags = [];

	tags.forEach((tag) => {
		const groupId = tag.tagGroupId;
		const target = normalizedGroups[groupId]
			? normalizedGroups[groupId].children
			: normalizedTags;
		target.push({name: tag.name});
	});

	return uniqBy(
		[
			...map(normalizedGroups, ({name, children}) => ({
				name: name,
				children: children,
			})),
			...map(normalizedTags, ({name}) => ({name: name, children: []})),
		],
		'name'
	);
}

export default function (state = initialState, action) {
	switch (action.type) {
		case 'ADD_FEATURE_SOURCE':
		case 'UPDATE_FEATURE_SOURCE':
			return action.key === FEATURE_SOURCE_ALL
				? buildHierarchy(get(action, 'data.metadata'))
				: state;
		case 'EMPTY_FEATURE_SOURCE':
		case 'DELETE_FEATURE_SOURCE':
			return [];
		default:
			return state;
	}
}
